import classNames from "classnames";
import { twMerge } from "tailwind-merge";

export const useClsx = (...args: classNames.ArgumentArray) => {
  return twMerge(classNames(...args));
};
